import * as binderWallColumns from "../enums/binderWallColumns";
import find from "lodash.find";

const COLUMNS = Object.keys(binderWallColumns).map(k => binderWallColumns[k]); // eslint-disable-line import/namespace

export default function getBinderWallColumnToggled(userColumns, columnName) {
	const userToggled = userColumns[columnName];
	if (userToggled === true || userToggled === false) {
		return userToggled;
	}
	const column = find(COLUMNS, col => col.name === columnName);
	return column ? !!column.default : false;
}
